import { Component, Input, ElementRef, OnDestroy, OnInit } from '@angular/core';

@Component({
  selector: 'tog-modal',
  templateUrl: 'modal.template.html',
  styleUrls: ['modal.scss']
})
export class ModalComponent implements OnInit, OnDestroy {
  @Input() id: string;
  @Input() forceToTop: boolean = false; // to ensure cancel modals are on top even when other modals are present
  @Input() set name(name: string) {
    this.id = name;
  }
  @Input() set allowClickAway(allow: boolean) {
    if (!allow) {
      this._el.nativeElement.getElementsByClassName('modal fade')[0].setAttribute('data-backdrop', 'static');
    }
  }

  private _modalBody: any;

  constructor(private _el: ElementRef) { }

  ngOnInit() {
    this._modalBody = this._el.nativeElement;
    document.body.appendChild(this._modalBody);
  }

  ngOnDestroy() {
    this.cleanUpBackdrops();
    if(this._modalBody) {
      document.body.removeChild(this._modalBody);
    }
  }

  // prevents grey-screen bug where an extra modal backdrop is left onscreen with no way to clear it
  cleanUpBackdrops() {
    let backdrops = document.getElementsByClassName('modal-backdrop');
    for (let i = 0; i < backdrops.length; i++) {
      if(backdrops[i]) {
        document.body.removeChild(backdrops[i]);
      }
    }
  }
}



// WEBPACK FOOTER //
// /app/src/app/shared/components/modal/modal.component.ts